import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import screen from 'superior-mq';
import InlineLink from '../inline-link';
import { hover, bp } from '../../styles/helpers';

const Button = ({
  href,
  children,
  black,
  small,
  isdark,
  ...rest
}) => (
  href
    ?
      <ButtonLink
        href={href}
        black={black ? 'black' : undefined}
        small={small ? 'small' : undefined}
        isdark={isdark ? 'onDark' : undefined}
        {...rest}
      >
        {children}
      </ButtonLink>
    :
      <StyledButton
        black={black}
        small={small}
        isdark={isdark}
        {...rest}
      >
        {children}
      </StyledButton>
);

const smallButton = `
  width: auto;
  padding: 0 24px;
  font-size: ${rem(16)};
  line-height: ${rem(40)};
`;

const buttonStyle = css`
  display: inline-block;
  width: 276px;
  text-align: center;
  color: #fff;
  line-height: ${rem(66)};
  font-weight: 600;
  cursor: pointer;
  transition: background-color .5s ease, color .5s ease;
  text-decoration: none;
  background-color: ${props => props.black ? props.theme.black : props.theme.blue};
  outline: none;

  &:not(:disabled) {
    ${ /* eslint-disable no-nested-ternary, indent */
      props => hover(`
        background-color: ${props.black
          ? props.theme.blue
          : props.isdark ? '#fff' : props.theme.black};
        color: ${props.isdark && !props.black ? props.theme.blue : '#fff'};
      `)
      /* eslint-disable no-nested-ternary, indent */
    }

    &:focus {
      background-color: ${props => props.black
        ? props.theme.blue
        : props.isdark ? '#fff' : props.theme.black};
      color: ${props => props.isdark && !props.black ? props.theme.blue : '#fff'};
    }
  }

  ${screen.below(bp.laptopSm, `
    min-width: 220px;
    line-height: ${rem(50)};
  `)}

  ${screen.below(bp.portrait, `
    min-width: 0;
    padding: 0 20px;
  `)}

  ${screen.below(bp.mobileSm, `
    font-size: ${rem(12)};
  `)};
`;

const StyledButton = styled.button`
  ${buttonStyle}
  font-size: ${rem(20)};
  font-family: ${props => props.theme.sansFont};
  border: 0;

  ${props => props.small && css`
    ${smallButton}
  `}

  &:disabled {
    opacity: .7;
    cursor: initial;
  }

  ${props => props.styles && css`
    ${props.styles}
  `}

  ${props => hover(`
    &:disabled {
      background-color: ${props.black ? props.theme.black : props.theme.blue};
    }
  `)}
`;

const ButtonLink = styled(InlineLink)`
  ${buttonStyle}

  ${props => props.small && css`
    ${smallButton}
  `}

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

Button.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  black: PropTypes.bool,
  small: PropTypes.bool,
  isdark: PropTypes.bool,
};

export default Button;
